import axios from 'axios';
import { baseURL } from '../utility/Constants'; 

const getCellMetrics = async (emsName, from, to) => {
  try {
    console.log('Fetching cell metrics:', { emsName, from, to }); 
    const response = await axios.post(`${baseURL}/cell-metrics-chart`, {
      emsName,
      from,
      to
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching cell metrics:', error);
    throw error;
  }
};

export const cellMetricsService = {
  getCellMetrics
};

export default cellMetricsService;
